
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="64" height="64" viewBox="37.72 38.3 64 64"><g transform="matrix(.46076 0 0 .46076 -20.152 18.349)"><use xlink:href="#a" fill="#577a82"/><use xlink:href="#b" fill="#65a08f"/><use xlink:href="#a" y="59.1" fill="#40aaa5"/><use xlink:href="#a" x="15" y="88.7" fill="#60c1af"/><use xlink:href="#b" x="14.9" y="88.7" fill="#a0d4a8"/></g><defs><path id="a" d="M234.7 63.9h-79.4c-5.7 0-10.3-4.6-10.3-10.3s4.6-10.3 10.3-10.3h79.4c5.7 0 10.3 4.6 10.3 10.3s-4.6 10.3-10.3 10.3z"/><path id="b" d="M219.8 93.5h-79.4c-5.7 0-10.3-4.6-10.3-10.3s4.6-10.3 10.3-10.3h79.4c5.7 0 10.3 4.6 10.3 10.3 0 5.6-4.6 10.3-10.3 10.3z"/></defs></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    